module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }